<template>
  <div class="trail col no-stretch keep-padding" v-if="showTrail" @click.prevent="toggleExpanded" :class="{'closed-trail': hasClosedStatus, 'expandable': expandable, 'expanded': expanded }">
    <div class="trail-collapsed" :class="trailClass">
      <div class="rating" :class="ratingClass"></div>
      <div class="trail-title-box">
        <TrailIcons :trail="trail" />
        <div class="trail-name">{{trail.Name}}</div>
        <div class="trail-status" :class="trailClass">{{trail.Status}}</div>
      </div>
    </div>
    <MobileTrailIcons :trail="trail" :expanded="expanded" v-if="expandable" />
  </div>
  <span v-else><!-- no show trail for transition-group --> </span>
</template>

<script>
import { mapGetters } from 'vuex';
import TrailIcons from '@/components/MountainAreas/TrailIcons.vue';
import MobileTrailIcons from '@/components/MountainAreas/MobileTrailIcons.vue';

export default {
  name: 'Trail',
  props: ['trail', 'index'],
  components: {
    TrailIcons,
    MobileTrailIcons,
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    ...mapGetters(['closedStatuses', 'openStatuses', 'mtnAreaToggles', 'resortSluggedName']),
    ratingClass() {
      const difficultyClass = this.trail.Difficulty.toLowerCase().replace(' ', '-');
      const trailIconClass = this.trail.TrailIcon.toLowerCase();

      // Tremblant doesn't want the snowshoe icon, but standard difficulty icons
      // This is a hack to do this quickly. If more of this happens, make a config setting
      if (difficultyClass.match(/snowshoe/) && this.resortSluggedName.match(/tremblant-fr|tremblant/)) {
        return `rating-${trailIconClass}`;
      }

      return `rating-${trailIconClass} rating-${difficultyClass}`;
    },
    trailClass() {
      return this.trail.StatusEnglish;
    },
    hasClosedStatus() {
      return this.closedStatuses.indexOf(this.trail.StatusEnglish) >= 0;
    },
    hasOpenStatus() {
      return this.openStatuses.indexOf(this.trail.StatusEnglish) >= 0;
    },
    showTrail() {
      if (this.mtnAreaToggles.groomingValue !== true) {
        return this.hasOpenStatus
          ? true
          : this.mtnAreaToggles.closedTrailsValue;
      }
      return this.hasOpenStatus && this.trailsIsGroomed();
    },
    expandable() {
      return !this.hasClosedStatus;
    },
  },
  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded;
    },
    trailsIsGroomed() {
      return this.trail.Grooming !== '--' && this.trail.Grooming !== 'No';
    },
  },
};
</script>

<style lang="scss" scoped>
  #dashboard {
    .trail {
      background-color: $white;
      margin-bottom: 20px;
      height: 60px;
      max-height: 60px;
      overflow: hidden;
      width: 100%;
      transition: all .5s ease-in-out;
      border-radius: 3px 3px 3px 3px;
      @media (min-width: $tablet) {
        height: 80px;
        max-height: 80px;
      }
      &.expanded {
        max-height: 130px;
      }
      &.expandable {
        height: auto;
        min-height: 60px;
        @media (min-width: $tablet) {
          min-height: 80px;
          height: 80px;
          max-height: 80px;
        }
      }
      .trail-collapsed {
        display: flex;
        flex: 1;
        line-height: 100%;
        padding: 15px 10px 12px;
        @media (min-width: $tablet) {
          padding: 29px 10px 22px;
        }
        @media (min-width: $tablet-landscape) {
          padding: 29px 15px 22px;
        }
      }
      .trail-title-box {
        display: inline-block;
        margin-top: 0px;
        width: 100%;
        @media (min-width: $tablet) {
          margin-top: -10px;
        }
      }
      .trail-name {
        color: $dark-gray;
        display: inline-block;
        font-family: $base-font-semibold;
        font-weight: 600;
        font-size: 14px;
        line-height: 1.2;
        letter-spacing: 0.2px;
        margin-right: 10px;
        max-width: 70%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        @media (max-width: $small-phone) {
          max-width: 65%;
        }
        @media (min-width: $tablet) {
          font-size: 22px;
        }
      }
      .trail-icons + .trail-name {
        @media (max-width: $small-phone) {
        }
      }
      .trail-status {
        color: $light-gray;
        font-size: 12px;
        font-weight: 300;
        line-height: 1.2;
        letter-spacing: 0.15px;
        margin-bottom: -10px;
        @media (min-width: $tablet) {
          font-size: 16px;
        }
        &.closed, &.closed_for_season {
          float: right;
          opacity: 0.8;
          text-transform: uppercase;
        }
      }
      .trail-collapsed {
        &.closed, &.closed_for_season {
          > .trail-title-box {
            margin-top: 8px;
            @media (min-width: $tablet) {
              margin-top: 0;
            }
          }
        }
      }
      &.closed-trail {
        .trail-name {
          color: $light-gray;
          font-family: $base-font-regular;
          font-weight: 300;
          opacity: 0.8;
        }
        .trail-icons, .trail-status {
          opacity: 0.8;
        }
        .trail-status {
          color: #434343;
        }
        .rating {
          opacity: 0.4;
        }
        &.expanded {
          height: 60px;
          max-height: 60px;
          .trail-expanded-data {
            display: none;
          }
          @media (min-width: $tablet) {
            height: 80px;
            max-height: 80px;
          }
        }
      }
    }
  }
</style>
